<template>
  <tr :class="{ 'row-with-error': hasError }">
    <td class="fuel-type-cell">
      <v-autocomplete
        :value="row.fuelType"
        :items="fuelTypes"
        item-text="name"
        item-value="name"
        dense
        hide-details
        clearable
        class="fuel-type-field"
        :class="{ 'field-error': hasFuelTypeError }"
        @input="$emit('update-field', 'fuelType', $event)"
      ></v-autocomplete>
      <span v-if="hasFuelTypeError" class="error-text">
        <v-icon x-small color="error">mdi-alert-circle</v-icon>
        {{ $t("LABELS.REQUIRED") }}
      </span>
    </td>

    <td class="qty-cell">
      <v-text-field
        :value="row.totalQty"
        type="number"
        step="0.01"
        dense
        hide-details
        @input="$emit('update-field', 'totalQty', parseFloat($event) || 0)"
      ></v-text-field>
    </td>

    <td class="price-cell">
      <v-text-field
        :value="row.price"
        type="number"
        step="0.01"
        dense
        hide-details
        @input="$emit('update-field', 'price', parseFloat($event) || 0)"
      ></v-text-field>
    </td>

    <td class="total-cell">
      <span class="total-price">{{ row.totalPrice }}</span>
    </td>

    <td class="actions-cell">
      <v-btn icon x-small color="error" @click="$emit('delete')">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
export default {
  name: "FuelExpenseFormRowItem",
  props: {
    row: {
      type: Object,
      required: true
    },
    fuelTypes: {
      type: Array,
      default: () => []
    },
    hasError: {
      type: Boolean,
      default: false
    },
    hasFuelTypeError: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.fuel-type-cell {
  width: 40%;
  padding-left: 24px;
  padding-right: 16px;
}

.qty-cell,
.price-cell {
  padding-right: 16px;
}

.total-cell {
  padding-right: 16px;
}

.actions-cell {
  text-align: center;
}

.fuel-type-field {
  min-width: 200px;
  max-width: 100%;
}

.total-price {
  font-weight: 500;
  color: #333;
  display: inline-block;
  padding: 8px 0;
}

.row-with-error {
  background-color: #fff5f5;
}

.field-error >>> .v-input__control {
  background-color: #ffe2e5 !important;
}

.field-error >>> .v-autocomplete__selection,
.field-error >>> .v-input__slot {
  border-color: #f64e60 !important;
}

.error-text {
  color: #f64e60;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}
</style>
